module.exports = __webpack_public_path__ + "static/Kids-f6558cf2e0358fb29a6dbf436d4146b2.jpg";